import { Chart, Series, Label, ArgumentAxis, Tooltip } from 'devextreme-react/chart';
import "./Barras.css";
import { LVForm } from "../../Basicos/LVForm";
import { SimpleItem } from 'devextreme-react/form';

export const BarrasStandard = ({ icono, titulo, dataSource, CampoEjeX, CampoEjeY, Titulo, Color }) => {

  const customizeTooltip = (pointInfo) => ({
    html: `<div><div class="tooltip-header">${
      pointInfo.argumentText
    }</div><div class="tooltip-body"><div class="series-name"><span class='top-series-name'>${
      pointInfo.points[0].seriesName
    }</span>: </div><div class="value-text"><span class='top-series-value'>${
      pointInfo.points[0].valueText
    }</span></div></div>`,
  });

  return (
    <div className="barras">
      <LVForm
        colCount={1}>
        <SimpleItem>
          <div className="title">
            {icono} {titulo}
          </div>
          <br />
          <Chart
            id="chart"
            dataSource={dataSource}
          >
            <ArgumentAxis>
              <Label overlappingBehavior="auto" />
            </ArgumentAxis>

            <Tooltip enabled={true} shared={true} customizeTooltip={customizeTooltip} />

            <Series
              valueField={CampoEjeY}
              argumentField={CampoEjeX}
              name={Titulo}
              type="bar"
              color={Color} />
          </Chart>
        </SimpleItem>
      </LVForm>
    </div>
  );
};
